import { render } from "./OrderCancellationNoticeModal.vue?vue&type=template&id=3f2c4e46"
import script from "./OrderCancellationNoticeModal.vue?vue&type=script&lang=js"
export * from "./OrderCancellationNoticeModal.vue?vue&type=script&lang=js"

import "./OrderCancellationNoticeModal.vue?vue&type=style&index=0&id=3f2c4e46&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__